import { FinanceType } from '@dav-core/finance-type.enum';
import { VehicleCondition } from '@dav-core/services/vehicle-condition.type';
import { VehicleType } from '@dav-core/vehicle-type.enum';
import { DecodeVinResponse } from '@dav-model/api/response/decode-vin.response';
import { ManualResponse } from '@dav-model/api/response/manual.response';
import { PostalResponse } from '@dav-model/api/response/postal.response.model';
import { ProductFormResponse } from '@dav-model/api/response/product-form.response.model';
import { SurchargeSelectionState } from '@dav-model/surcharge-selection-state.model';

import * as VehicleActions from './vehicle.actions';

export interface VehicleValues {
  YamahaSurcharges: SurchargeSelectionState[] | undefined;
  isOldVehicleCondition: boolean | undefined;
  isCreditAvailable: boolean | undefined;
  isValidSaveCredit: boolean | undefined;
  vin: string | undefined;
  hin: string | undefined;
  pid: string | undefined;
  tin: string | undefined;
  other: string | undefined;
  make: string | undefined;
  otherMake: string | undefined;
  model: string | undefined;
  financeType: FinanceType | undefined;
  vehicleType: { value: VehicleType } | undefined;
  vehicleCondition: VehicleCondition | undefined;
  engine: number | undefined;
  province: string;
  customerTaxExempt?: string;
}

export interface State {
  productForm: ProductFormResponse;
  values: VehicleValues;
  vin: DecodeVinResponse;
  postal: PostalResponse;
  error: string;
  status: boolean;
  decodeVinTries: number;
  manualDecode: ManualResponse;
}

const initialState: State = {
  productForm: new ProductFormResponse(),
  values: {
    YamahaSurcharges: undefined,
    isOldVehicleCondition: undefined,
    isCreditAvailable: undefined,
    isValidSaveCredit: undefined,
    vin: undefined,
    hin: undefined,
    pid: undefined,
    tin: undefined,
    other: undefined,
    make: undefined,
    otherMake: undefined,
    model: undefined,
    financeType: undefined,
    vehicleType: undefined,
    vehicleCondition: undefined,
    engine: undefined,
    province: ''
  },
  postal: new PostalResponse(),
  vin: new DecodeVinResponse(),
  error: '',
  status: false,
  decodeVinTries: 0,
  manualDecode: new ManualResponse(),
};

export function reducer(state = initialState, action: VehicleActions.All): State {
  switch (action.type) {
    case VehicleActions.GET_PRODUCT_FORM_SUCCESS: {
      return {
        ...state,
        productForm: action.payload,
      };
    }

    case VehicleActions.UPDATE_PRODUCT_FORM: {
      return {
        ...state,
        values: {
          ...initialState.values,
          ...action.payload,
        },
      };
    }

    case VehicleActions.GET_CUSTOMER_POSTAL_SUCCESS: {
      return {
        ...state,
        postal: action.payload,
      };
    }

    case VehicleActions.DECODE_VIN_SUCCESS: {
      return {
        ...state,
        vin: action.payload,
        decodeVinTries: 0,
        error: '',
      };
    }

    case VehicleActions.CLEAR_CUSTOMER_POSTAL: {
      return {
        ...state,
        postal: new PostalResponse(),
      };
    }

    case VehicleActions.DECODE_VIN_MANUAL: {
      return {
        ...state,
        manualDecode: action.payload,
        error: '',
      };
    }

    case VehicleActions.GET_MAKE_SUCCESS: {
      return {
        ...state,
        manualDecode: { ...state.manualDecode, make: action.payload },
        error: '',
      };
    }

    case VehicleActions.GET_YEAR_SUCCESS: {
      return {
        ...state,
        manualDecode: { ...state.manualDecode, year: action.payload },
        error: '',
      };
    }

    case VehicleActions.GET_MODEL_SUCCESS: {
      return {
        ...state,
        manualDecode: { ...state.manualDecode, model: action.payload },
        error: '',
      };
    }

    case VehicleActions.GET_TRIM_SUCCESS: {
      return {
        ...state,
        manualDecode: { ...state.manualDecode, trim: action.payload },
        error: '',
      };
    }

    case VehicleActions.SHOW_INSERVICE_DATE_AND_ODO: {
      const vin = state.vin;
      vin.manualDecode = true;

      return {
        ...state,
        vin: vin,
        error: '',
      };
    }

    case VehicleActions.LOAD_VEHICLE_QUOTE: {
      action.payload.VehicleState.vin['loadQuote'] = true;

      return {
        ...state,
        productForm: action.payload.VehicleState.productForm,
        values: action.payload.VehicleState.values,
        status: action.payload.VehicleState.status,
        vin: action.payload.VehicleState.vin,
        postal: action.payload.VehicleState.postal ? action.payload.VehicleState.postal : new PostalResponse(),
      };
    }

    case VehicleActions.VEHICLE_FAILURE: {
      const vinReset = new DecodeVinResponse();
      vinReset.vin = state.vin.vin;
      console.warn('Vehicle failure');

      return {
        ...state,
        error: action.payload,
        vin: vinReset,
        decodeVinTries: state.decodeVinTries + 1,
      };
    }

    case VehicleActions.RESET_PRODUCT_FORM: {
      return {
        ...state,
        values: {
          ...initialState.values,
        },
        decodeVinTries: 0,
        vin: new DecodeVinResponse(),
        postal: new PostalResponse(),
        error: '',
        status: false,
      };
    }

    case VehicleActions.SET_VEHICLE_CONDITION: {
      return {
        ...state,
        values: {
          ...state.values,
          isOldVehicleCondition: action.payload,
        },
      };
    }
    case VehicleActions.SET_CREDIT_STATUS: {
      return {
        ...state,
        values: {
          ...state.values,
          isCreditAvailable: action.payload,
        },
      };
    }

    case VehicleActions.SET_SAVE_CREDIT: {
      return {
        ...state,
        values: {
          ...state.values,
          isValidSaveCredit: action.payload,
        },
      };
    }

    default: {
      return state;
    }
  }
}
